module.exports = __webpack_public_path__ + "static/media/head_logo.a9e95ce1.png";